import {useLocationState} from './useLocation';

export const useRouteEntities = <T>() => {
  const state = useLocationState<{entities?: T}>();
  const routeEntities = state?.entities;
  return ((routeEntities as T) ?? {}) as T | {[key: string]: unknown};
};
